/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_UpdateInputs */

const cs_enum_update = /** @type {(inputs: Enum_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úprava`)
};

const en_enum_update = /** @type {(inputs: Enum_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update`)
};

/**
* | output |
* | --- |
* | "Update" |
*
* @param {Enum_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_update = /** @type {((inputs?: Enum_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_update(inputs)
	return cs_enum_update(inputs)
});